import react, { useState, useEffect, useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { ImFilePdf } from "react-icons/im";
import { FcImageFile } from "react-icons/fc";
import { GrAttachment } from "react-icons/gr";
import { useFieldArray } from "react-hook-form";
import moment from "moment";
import { convertNumberInToMask } from "../../components/supportHelperFunction";
import MainPageDialog from "../../components/dialog";
import { Loader } from "../../components/loader";
import { useGetPatientQuery } from "../../services/patientService";
import { useGroupChatContext } from "../../context/groupchatContext";
import { CreatableSelectField } from "../../components/reactHookFormFields/creatableSelectField";
import { AsyncCreatableSelectField } from "../../components/reactHookFormFields/asyncCreatableSelectField";
import { TextAreaField } from "../../components/reactHookFormFields/textAreaFields";
import { ReactSelectField } from "../../components/reactHookFormFields/selectField";
import { MaskField } from "../../components/reactHookFormFields/maskField";
import { getBaseUrl } from "../../helpers/utility";
import { Icon } from "../../helpers/icons";
import { formatBytes } from "../../components/common";
import { InputField } from "../../components/reactHookFormFields/inputField";
import { useGetEfaxInfoQuery, useShareEfaxMutation, useShareReportMutation } from "../../services/procedureService";
import { usePrepareDataMutation } from "../../services/shareDataService";

export const ShareOptions = ({
    setShowPrintShareView,
    setShowShareeFax,
    printData,
    sharePreviewUrl,
    userUniqueId,
    setLoadingShare = false,
    loadingShare,
    bulk = false,
    title
}) => {

    const [previewUuid, setPreviewUuid] = useState();
    const [transectionId, setTransectionId] = useState();
    const [efaxFromFieldData, setEfaxFromFieldData] = useState();


    const {
        handleSubmit,
        control,
        reset,
        setValue,
        formState: { errors },
    } = useForm({});

    const {
        append: appendData,
        remove: removeData,
        fields: fieldsData,
    } = useFieldArray({
        control,
        name: "share_data",
        rules: { minLength: 1 },
    });

    useEffect(() => {
        setValue("share_data", userUniqueId);
    }, []);

    const [shareEfax] = useShareEfaxMutation();
    const [shareEmail] = useShareReportMutation();

    const groupChatContext = useGroupChatContext();
    const {authData, selectedChat, practice_id} = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
        practice_id: groupChatContext.authData.practice?.id
    }));


    const [viewType, setViewType] = useState("fax");
    const [resetEmail, setResetEmail] = useState(false);
    const [resetPhone, setResetPhone] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);

    const [data, setData] = useState();

    const { data: eFaxInfo } = useGetEfaxInfoQuery();
    const [prepareData, { isLoading: prepareDataLoading }] = usePrepareDataMutation();
    const { data: selectedPatient } = useGetPatientQuery(selectedChat?.pid);

    const printIframe = (data) => {
        let api_url = getBaseUrl().api_url;
        let fileUrl = `${api_url}/${sharePreviewUrl}=${
        bulk ? data?.content : previewUuid[0]?.content
        }&token=${authData.auth}&tz=${new Date().getTimezoneOffset()}`;
        window.open(fileUrl, "_blank", "noreferrer");
    };

    useEffect(() => {
        if (viewType == "fax" && efaxFromFieldData && efaxFromFieldData?.length > 0) {
            let findAccId = efaxFromFieldData?.find((v)=>v?.accId == (userUniqueId?.location_efax || userUniqueId?.practice_location_efax || userUniqueId?.efax));
            setValue("phone", undefined);
            setValue("email", undefined);
            if(efaxFromFieldData?.length == 1){
                setValue("account_id", {
                ...efaxFromFieldData[0],
                value: efaxFromFieldData[0]?.account_id,
                });
            }
            else if((userUniqueId?.linked_encounter && userUniqueId?.linked_encounter != "") || (userUniqueId?.practice_location_efax != "" && userUniqueId?.practice_location_efax) || (userUniqueId?.efax != "" && userUniqueId?.efax)){
                setValue("account_id", findAccId ? {
                    ...findAccId,
                    //value: userUniqueId?.location_efax || userUniqueId?.practice_location_efax || userUniqueId?.efax,
                    value:`${findAccId?.account_id}`
                } : undefined);
            }
        }
        else if (viewType == "email") {
            setValue("account_id", undefined);
            setValue("fax", undefined);
            setValue("subject", undefined);
        }
    }, [eFaxInfo, viewType, userUniqueId, efaxFromFieldData]);

    useEffect(() => {
        if ((resetEmail || selectedPatient?.Patient?.email) && viewType == "email"){
            setValue("email", selectedPatient?.Patient?.email);
        }
        else{
            setValue("email", undefined);
        }

        if((resetPhone || selectedPatient?.Patient?.phone_cell) && viewType == "email"){
            setValue("phone", convertNumberInToMask(selectedPatient?.Patient?.phone_cell));
        }
        else {
            setValue("phone", undefined);
        }
    }, [viewType, resetEmail, resetPhone]);

    useEffect(() => {
        var sendObj = "";
        if (bulk) {
            const objA = userUniqueId?.map((v) => {
                return {
                    content: v?.uuid,
                    mime_type: v?.mime_type,
                    order: 1,
                    title: v?.title,
                    type: "file",
                };
            });

            sendObj = {
                // encounter_id: selectedNote?.encounter,
                details: objA,
                pid: selectedChat?.pid,
                is_ccm: "0",
                is_rpm: "0",
                practice_id: practice_id,
            };
        }
        else {
            sendObj = {
                // encounter_id: selectedNote?.encounter,
                details: [
                {
                    content: userUniqueId?.uuid,
                    mime_type: "application/pdf",
                    order: 1,
                    title: userUniqueId?.title,
                    type: "file",
                },
                ],
                pid: selectedChat?.pid,
                is_ccm: "0",
                is_rpm: "0",
                practice_id: practice_id,
            };
        }
        setPreviewLoading(true);
        prepareData(sendObj).then((res) => {
            setPreviewLoading(false);
            setPreviewUuid(res?.data?.meta?.ShareDataTransaction?.details);
            setTransectionId(res?.data?.meta?.ShareDataTransaction?.id);
        });
    }, [userUniqueId]);

    const ShareTypes = [
        {
            id: "email",
            label: "Email/Phone",
            selected: false,
        },
        {
            id: "fax",
            label: "eFax",
            selected: true,
        },
    ];

    useEffect(() => {
        // if lab is Exact Sciences
        if (printData?.referring_to_fax) {
            setValue("fax", {
                label: printData?.referring_to_fax,
                value: printData?.referring_to_fax,
            });
        }
    }, [printData, userUniqueId]);
  
    const onSubmit = (data, e) => {
        if(setLoadingShare){
            setLoadingShare(true);
        }

        delete data?.share_via;
        if(transectionId) {
            data.share_data_transaction_id = transectionId;
        }
        if(viewType == "email") {
            data.dob_required = "0";
            data.phone = data?.phone?.replace(/[^A-Z0-9]/gi, "");
        }
        if(viewType == "fax") {
            data.file = [printData?.uuid];
        }
        if(previewUuid?.length > 0) {
            data.file = previewUuid?.map((v) => v?.content);
        }

        const sendObj = {
            ...data,
            account_id: data?.account_id?.value,
            fax: data?.fax?.value,
            share_type: data?.share_via?.id,
            procedure_id: printData?.id,
            //file:[printData?.uuid],
            share_hash: printData?.share_hash,
            pid: selectedChat?.pid,
        };
        
        if (viewType === "email") {
            setShowShareeFax(false);
            shareEmail(sendObj).then((res) => {
                if (setLoadingShare) {
                    setLoadingShare(false);
                }
                if (setShowPrintShareView) {
                    setShowPrintShareView(false);
                }
                if (res?.data?.response?.code == 0) {
                    toast.success(res?.data?.response?.msg);
                } else if (res?.data?.code == 0) {
                    toast.success(res?.data?.msg);
                }
            });
        } else {
            if(printData?.referral_no) {
                sendObj.attached_entities = [
                    { entity: "referrals", entity_id: printData.id },
                ];
            }
            setShowShareeFax(false);
            shareEfax(sendObj).then((res) => {
                if (setLoadingShare) {
                    setLoadingShare(false);
                }
                if (setShowPrintShareView) {
                    setShowPrintShareView(false);
                }
                if(res?.data?.response?.code == 0) {
                    toast.success(res?.data?.response?.msg);
                }
                else if (res?.data?.code == 0) {
                    toast.success(res?.data?.msg);
                }
            });
        }
    };

    const promiseOptions = async (inputValue, selectFirst) => {
        let api_url = getBaseUrl().api_url;
        const response = await axios.get(
        `${api_url}/fax_address_book/index.json`,
        {
            params: {
            pid: selectedChat?.pid,
            keyword: inputValue,
            // audit_encounter_id: selectedNote?.encounter,
            current_loc: "patient/encounter/provider_note/elements/preview",
            },
        }
        );
        let resData = [];
        resData = response?.data?.response?.data || [];
        const optionsList = resData.map((fax) => ({
        ...fax,
        value: fax?.fax,
        label: `${fax?.name}  (${fax?.fax})`,
        }));

        return optionsList;
    };

    const footerList = [
        {
            title: "Cancel",
            type: "cancel",
            action: () => setShowShareeFax(false),
        },
        {
            title: "Send",
            type: "save",
            action: () => handleSubmit(onSubmit)(),
        },
    ];

    const shareTypeWatcher =
        useWatch({
        control,
        name: "share_via",
        defaultValue: { ...ShareTypes[1] },
        }) || (printData?.lab_ppid == "198" ? ShareTypes[1] : ShareTypes[0]);


    useEffect(() => {
        if (shareTypeWatcher) {
        setViewType(shareTypeWatcher?.id);
        }
    }, [shareTypeWatcher]);

    const handleRemove = (data) => {
        setPreviewUuid(previewUuid.filter((v) => data.content != v.content));
    };

    useEffect(()=>{
        if(title=="ACOG Report"){
            setValue("subject",`ACOG report for ${selectedPatient?.Patient?.FirstName ? selectedPatient?.Patient?.FirstName : ""} ${selectedPatient?.Patient?.LastName ? selectedPatient?.Patient?.LastName : ""} (${selectedPatient?.Patient?.Gender ? selectedPatient?.Patient?.Gender : ""}, ${ moment(selectedPatient?.Patient?.DateOfBirth).format("MM/DD/YYYY")})`)
            setValue("message",`ACOG report for ${selectedPatient?.Patient?.FirstName ? selectedPatient?.Patient?.FirstName : ""} ${selectedPatient?.Patient?.LastName ? selectedPatient?.Patient?.LastName : ""} (${selectedPatient?.Patient?.Gender ? selectedPatient?.Patient?.Gender : ""}, ${ moment(selectedPatient?.Patient?.DateOfBirth).format("MM/DD/YYYY")})`)
        }
        else if (title=="Lab Order" || title == "Referral" || title == "Radiology Order"){
            setValue("subject",`ORDER`)
            setValue("message",`ORDER`)
        }
    }, [selectedPatient,title])

    useEffect(()=>{
        setEfaxFromFieldData(eFaxInfo?.response?.data?.map((v)=>{
        if(v?.account_title != "") return {...v, account_id:`${v?.account_title} (${v?.account_id})`,accId:v?.account_id}
            return v;
        }))
    },[eFaxInfo])

    return (
        <MainPageDialog
            maxHeight={true}
            title="Share"
            footer={true}
            footerList={footerList}
            modalSize="md"
            onCancelHandler={() => setShowShareeFax(false)}
        >
            {loadingShare && (
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-30">
                    <Loader />
                </div>
            )}
            <form id="share data form" onSubmit={handleSubmit(onSubmit)}>
                <div className="grid grid-cols-12 gap-4 mt-2">
                    <div className="col-span-3">
                        <ReactSelectField
                            menuPlacement="bottom"
                            title="Share Via"
                            name="share_via"
                            control={control}
                            rules={{
                            required: {
                                value: true,
                                message: "please enter value",
                            },
                            }}
                            errors={errors}
                            optionData={ShareTypes}
                            defaultValue={
                            ShareTypes.filter((v) => {
                                if (v?.selected) {
                                return { ...v, label: v.label };
                                }
                            })[0]
                            }
                        />
                    </div>
                    {viewType === "email" ? (
                    <>
                        <div className="col-span-4">
                            {/* <p className="flex justify-end">
                                <span
                                className="text-blue-500 cursor-pointer"
                                onClick={() => setResetEmail(!resetEmail)}
                                >
                                Use Patient Email
                                </span>
                            </p> */}
                            <InputField
                                title="Email"
                                name="email"
                                control={control}
                                rules={{
                                required: {
                                    value: true,
                                    message: "please enter value",
                                },
                                }}
                            />
                        </div>
                        <div className="col-span-5">
                            {/* <p className="flex justify-end">
                                <span
                                    className="text-blue-500 cursor-pointer"
                                    onClick={() => setResetPhone(!resetPhone)}
                                >
                                    Use Patient Phone
                                </span>
                            </p> */}
                            <MaskField
                                mask="(999) 999-9999"
                                name="phone"
                                control={control}
                                title="Phone"
                                rules={{
                                required: {
                                    value: false,
                                    message: "Please Enter value",
                                },
                                pattern: {
                                    value:
                                    /^^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                                    message: "invalid email address",
                                },
                                }}
                                errors={errors}
                            />
                        </div>
                    </>
                    ) : (
                    <>
                        <div className="col-span-4 text-left">
                            <CreatableSelectField
                                showLabel="value"
                                menuPlacement="bottom"
                                title="From"
                                name="account_id"
                                control={control}
                                rules={{
                                required: {
                                    value: true,
                                    message: "please enter value",
                                },
                                }}
                                errors={errors}
                                optionData={efaxFromFieldData?.map((v, k) => ({
                                ...v,
                                value: v.account_id,
                                }))}
                                defaultValue={data}
                            />
                        </div>
                        <div className="col-span-5 text-left">
                            <AsyncCreatableSelectField
                                menuPlacement="bottom"
                                search={promiseOptions}
                                title="To"
                                showLabel="label"
                                name="fax"
                                control={control}
                                rules={{
                                required: {
                                    value: true,
                                    message: "please enter value",
                                },
                                }}
                                errors={errors}
                            />
                        </div>
                        <div className="col-span-12 ">
                            <InputField
                                title="Subject"
                                name="subject"
                                control={control}
                                errors={errors}
                                rules={{
                                    required: {
                                        value: true,
                                        message: "please enter value",
                                    },
                                }}
                            />
                        </div>
                    </>
                    )}
                </div>

                <div className="col-span-12 w-full mt-3 ">
                    <TextAreaField
                        rows={8}
                        className="w-full"
                        title="Message"
                        name="message"
                        errors={errors}
                        rules={{
                            required: { value: viewType === "email" ? false : true },
                        }}
                        nusa_concept_name="Message"
                        nusa_enabled={true}
                        control={control}
                    />
                </div>

                <div className="col-span-12 w-full mt-3 ">
                    {userUniqueId && (
                        <div>
                            {previewLoading ? (
                                <div role="status" className="col-span-1">
                                    <svg
                                    className="inline mr-2 w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                                    viewBox="0 0 100 101"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                        fill="currentColor"
                                    />
                                    <path
                                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                        fill="currentFill"
                                    />
                                    </svg>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            ) : (
                                previewUuid?.map((v, index) => (
                                    <p className="flex">
                                    <>
                                        <span
                                        key={index}
                                        className={`text-red-500 ${v.content}`}
                                        >
                                        {v?.mime_type == "image/jpeg" ? (
                                            <FcImageFile style={{ fontSize: "18px" }} />
                                        ) : v?.mime_type == "application/pdf" ? (
                                            <ImFilePdf style={{ fontSize: "15px" }} />
                                        ) : (
                                            <GrAttachment style={{ fontSize: "15px" }} />
                                        )}
                                        </span>
                                        <span
                                        onClick={() => printIframe(v)}
                                        className="text-blue-500 cursor-pointer ml-1"
                                        >{`${v?.title ? v.title : "Preview"}`}</span>{" "}
                                        {v?.file_size && (
                                        <span className="ml-2">
                                            {`(Pages: ${v?.page_count} Size: ${formatBytes(
                                            v?.file_size
                                            )})`}
                                        </span>
                                        )}
                                        <span
                                            onClick={() => handleRemove(v)}
                                            className="text-red-500 cursor-pointer"
                                        >
                                            <Icon type="cross" />
                                        </span>
                                    </>
                                    </p>
                                ))
                            )}
                        </div>
                    )}
                </div>
            </form>
        </MainPageDialog>
    );
};

export default ShareOptions;